import { render } from "./PolicyInfo.vue?vue&type=template&id=c9e19d94&scoped=true"
import script from "./PolicyInfo.vue?vue&type=script&lang=js"
export * from "./PolicyInfo.vue?vue&type=script&lang=js"

import "./PolicyInfo.vue?vue&type=style&index=0&id=c9e19d94&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9e19d94"]])

export default __exports__